import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

export class GenderScrapper extends Component {
  Scrap = () => {
    let Prular = '';
    const cheerio = require('cheerio');
    const request = require('request');

    request(
      {
        method: 'GET',

        url:
          'https://uplifted-stream-263318.ey.r.appspot.com/https://www.dict.cc/?s=' +
          this.props.SearchedWord,
      },
      (err, res, body) => {
        if (err) return console.error(err);
        let $ = cheerio.load(body);
        //Language2 = $("small").text(); div#maincontent tr:nth-child(1) > td:nth-child(2) > a:nth-child(3)
        // $(".nominal span.vReg").each(function (i, e) {
        //   if (i == 1) PresentParticiple = $(this).text();
        //   if (i == 0) PastParticiple = $(this).text();
        // });   div#maincontent td:nth-child(2) > table > tbody > tr:nth-child(1) > td:nth-child(2) > a:nth-child(3)
        Prular = $(
          'div#maincontent tr:nth-child(1) > td:nth-child(2) > a:nth-child(3)'
        ).text();
        // Prular = $(
        //   'div#maincontent td:nth-child(2) > table > tbody > tr:nth-child(1) > td:nth-child(2) > a:nth-child(3)'
        // ).text();
        this.props.ScrapperCall(Prular);
      }
    );
  };

  render() {
    return (
      <div>
        <Button
          onClick={() => this.Scrap()}
          variant="contained"
          color="secondary"
        >
          Scrap
        </Button>
      </div>
    );
  }
}

export default GenderScrapper;
